import { gql } from 'apollo-angular';

export const announcementsFieldsV2 = `
  edges {
    cursor
    node {
      id
      title
      text
      publishedAt
      pinned
    }
  }
  pageInfo {
    hasPreviousPage
    hasNextPage
    startCursor
    endCursor
  }
`;

export const announcementFieldsV2 = `
  id
  title
  text
  publishedAt
  attachments {
    id
    fileName
    extension
  }
`;

export const announcementsQueryV2 = gql`
  query publishedAnnouncementsV2($limit: Int, $offset: Int) {
    publishedAnnouncementsV2 (limit: $limit, offset: $offset) {
      ${announcementsFieldsV2}
    }
  }
`;

export const announcementQueryV2 = gql`
  query getAnnouncementV2($announcementId: ID!) {
    getAnnouncementV2 (announcementId: $announcementId) {
      ${announcementFieldsV2}
    }
  }
`;
